import 'bootstrap/dist/css/bootstrap.min.css'
// Bundled rather than loaded from Google Fonts: this page is opened from exactly the kind of
// locked-down network that blocks outside CDNs, and a broken-looking firewall test is no test.
import '@fontsource/roboto/latin-400.css'
import '@fontsource/roboto/latin-500.css'
import '@fontsource/roboto/latin-700.css'
import '@fontsource/roboto-slab/latin-500.css'
import '@fontsource/roboto-slab/latin-700.css'
import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import { BRAND } from './lib/brand'
import { enforceHttps } from './lib/https-redirect'
import * as da from './strings/da'

// Before anything else: the test needs a secure context, and running it over http would report a
// missing one as a blocked WebSocket.
enforceHttps()

// The static title in index.html carries no brand; the deployed name is only known at runtime.
document.title = `${da.page.title} · ${BRAND}`

createApp(App).mount('#app')
